import { render, staticRenderFns } from "./Leyes-decretos-collapse.vue?vue&type=template&id=06fdb678&scoped=true"
import script from "./Leyes-decretos-collapse.vue?vue&type=script&lang=js"
export * from "./Leyes-decretos-collapse.vue?vue&type=script&lang=js"
import style0 from "./Leyes-decretos-collapse.vue?vue&type=style&index=0&id=06fdb678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fdb678",
  null
  
)

export default component.exports